var _path, _g, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76821 10.5817C8.3955 10.5817 10.5364 8.43544 10.5364 5.79087C10.5364 3.1511 8.3955 1 5.76821 1C3.13616 1 1 3.1511 1 5.79087C1 8.39061 3.06436 10.5089 5.63481 10.5799L5.76821 10.5817Z",
    fill: "url(#paint0_linear_9308_7423)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_9308_7423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.73689 8.34611C7.13811 8.34611 8.27994 7.20141 8.27994 5.79097C8.27994 4.38309 7.13811 3.23584 5.73689 3.23584C4.33313 3.23584 3.19385 4.38309 3.19385 5.79097C3.19385 7.1775 4.29484 8.30723 5.66575 8.34512L5.73689 8.34611Z",
    fill: "#FFBC00"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -0.542704,
    y: -2.60484,
    width: 22.1055,
    height: 22.1674
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.19px)",
      clipPath: "url(#bgblur_0_9308_7423_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4.38023,
    d: "M10.5103 1.86719C14.1369 1.86728 17.0911 4.83574 17.0913 8.47852C17.0913 12.1281 14.137 15.0907 10.5103 15.0908H10.5093L10.3276 15.0889H10.3257C6.7775 14.9906 3.9292 12.0661 3.9292 8.47852C3.92942 4.83575 6.87701 1.86719 10.5103 1.86719Z",
    fill: "#FFBC00",
    fillOpacity: 0.2,
    stroke: "url(#paint1_linear_9308_7423)",
    strokeWidth: 0.18251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 6.34695,
    y: 2.9899,
    width: 8.71137,
    height: 10.9821
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.37px)",
      clipPath: "url(#bgblur_1_9308_7423_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9308_7423)",
    "data-figma-bg-blur-radius": 2.73764
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.23144 6.56222C9.03674 6.37311 9.03674 6.06663 9.22495 5.871C9.3223 5.77319 9.44561 5.72754 9.57542 5.72754C9.69873 5.72754 9.82204 5.77319 9.9129 5.871L12.1779 8.13375C12.2688 8.22505 12.3207 8.34894 12.3207 8.47936C12.3207 8.60978 12.2688 8.73368 12.1779 8.82497L9.9129 11.0877C9.72469 11.2834 9.41965 11.2834 9.22495 11.0877C9.03674 10.8986 9.03674 10.5856 9.23144 10.3965L11.146 8.47936L9.23144 6.56222Z",
    fill: "url(#paint2_linear_9308_7423)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57581 5.74609C9.69448 5.74619 9.81212 5.79023 9.89905 5.88379H9.90002L12.1647 8.14648C12.2522 8.23439 12.3024 8.35394 12.3024 8.47949C12.3023 8.605 12.2521 8.72463 12.1647 8.8125L9.90002 11.0752C9.71917 11.2632 9.42561 11.2636 9.23792 11.0752C9.05683 10.8932 9.05642 10.5912 9.24377 10.4092H9.24475L11.1588 8.49219L11.1715 8.47949L11.1588 8.4668L9.24475 6.5498L9.24377 6.54883C9.08029 6.38973 9.05955 6.14416 9.17834 5.95898L9.23792 5.88379C9.33157 5.78971 9.45051 5.74609 9.57581 5.74609Z",
    stroke: "url(#paint3_linear_9308_7423)",
    strokeOpacity: 0.5,
    strokeWidth: 0.0365019
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9308_7423",
    x: 0.273695,
    y: 0.315688,
    width: 10.9264,
    height: 10.9507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.46008,
    result: "effect1_foregroundBlur_9308_7423"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7423_clip_path",
    transform: "translate(0.542704 2.60484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5103 1.86719C14.1369 1.86728 17.0911 4.83574 17.0913 8.47852C17.0913 12.1281 14.137 15.0907 10.5103 15.0908H10.5093L10.3276 15.0889H10.3257C6.7775 14.9906 3.9292 12.0661 3.9292 8.47852C3.92942 4.83575 6.87701 1.86719 10.5103 1.86719Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9308_7423",
    x: 6.34695,
    y: 2.9899,
    width: 8.71137,
    height: 10.9821,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.912548,
    dy: 0.912548
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.912548
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.737255 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7423_clip_path",
    transform: "translate(-6.34695 -2.9899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.23144 6.56222C9.03674 6.37311 9.03674 6.06663 9.22495 5.871C9.3223 5.77319 9.44561 5.72754 9.57542 5.72754C9.69873 5.72754 9.82204 5.77319 9.9129 5.871L12.1779 8.13375C12.2688 8.22505 12.3207 8.34894 12.3207 8.47936C12.3207 8.60978 12.2688 8.73368 12.1779 8.82497L9.9129 11.0877C9.72469 11.2834 9.41965 11.2834 9.22495 11.0877C9.03674 10.8986 9.03674 10.5856 9.23144 10.3965L11.146 8.47936L9.23144 6.56222Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7423",
    x1: 10.5364,
    y1: 1,
    x2: 3.77551,
    y2: 8.86983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7423",
    x1: 6.08625,
    y1: 3.4774,
    x2: 14.4138,
    y2: 13.7424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9308_7423",
    x1: 12.0913,
    y1: 6.72198,
    x2: 8.48404,
    y2: 6.79109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9308_7423",
    x1: 9.4332,
    y1: 7.57484,
    x2: 12.1812,
    y2: 7.58376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.c053a3f263eea9b068924a979189194f.svg";
export { ForwardRef as ReactComponent };